import customerFullcont from "./customer-fullcont.html";

const dialog = require('../../../../../components/dialog/dialog')
const fullcontEntity = require('../../../../../components/fullcont/fullcont-entity')
const fullcontHandler = require('../../../../../components/fullcont/fullcont-handler')
const handler = require('./customer-fullcont-handler')
const extrainfo = require('./customer-fullcont-extrainfo')
const customerDt = require('./customer-dt')
const customerMenu = require('./customer-menu')
const { formCopy } = require('./customer-fullcont-form')
const { form } = require('./customer-fullcont-form')
const { customerMT } = require('./customer-fullcont-multitable')
const customerEmailTracking = require('./customer-email-tracking')
const customerJump = require('./customer-jump')
const dtHandler = require('../../../../../components/dt/dt-handler')
const navmenu = require('../../../../../components/navmenu/navmenu')

const { generateImage } = require('../../../../../components/avatar/avatar-generator')

/****************ELEMENTS*****************/
var htmlFc = {}
var HTMLwasSelected = false

function HTMLselect(detail) {

      fullcontHandler.HTMLselect(

            'customer', //database table name****
            'customer', //dest entity on js
            'customer-fullcont',
            customerFullcont, form, formCopy, customerMT,
            editDialog, deleteDialog, dtCall, htmlFc)

      HTMLwasSelected = true
      handler.initDataFc(htmlFc)
      // htmlFc.hasFiles = true
      // fullcontHandler.rightsControl(htmlFc)
}/**/


export function start(detail) {  //console.log('customer-dt 5>', detail)

      if (!HTMLwasSelected) { HTMLselect(detail) }

      obj[detail.act].start(detail)
}/**/


const obj = {

      addOne: { start: (detail) => { addOne(detail, htmlFc) } },
      cancelEdit: { start: (detail) => { fullcontEntity.cancelEdit(detail, htmlFc) } },
      deleteEntity: { start: (detail) => { fullcontEntity.deleteEntity(detail, htmlFc) } },
      deleteFromDialog: { start: (detail) => { deleteFromDialog(detail, htmlFc) } },
      discard: { start: (detail) => { fullcontHandler.discard(detail, htmlFc) } },
      fullcontOptions: { start: (detail) => { customerMenu.start(detail, 'htmlDt', htmlFc) } },
      hide: { start: (detail) => { fullcontEntity.hide(detail, htmlFc), extrainfo.clean(htmlFc) } },
      prepareAdd: { start: (detail) => { prepareAdd(detail) } },
      prepareEdit: { start: (detail) => { prepareEdit(detail, htmlFc) } },
      saveFromDialog: { start: (detail) => { saveFromDialog(detail, htmlFc) } },
      selectOne: { start: (detail) => { fullcontEntity.selectOne(detail, htmlFc, processSelectOne) } },
      selectOneNoCheck: { start: (detail) => { fullcontEntity.selectOneNoCheck(detail, htmlFc, processSelectOne) } },
      update: { start: (detail) => { update(detail, htmlFc) } },
      addBillingToShipping: { start: (detail) => { handler.addBillingToShipping(detail, htmlFc) } },
      jump: { start: (detail) => { customerJump.start(detail, htmlFc) } },
      checkEmailInput: { start: (detail) => { handler.checkEmailInput(htmlFc) } },
      sendEmailFromButton: { start: (detail) => { handler.sendEmailFromButton(htmlFc) } },
      printBehaivor: { start: (detail) => { extrainfo.printBehaivor(detail, htmlFc) } },
      printReport: { start: (detail) => { handler.printReport(detail, htmlFc) } },

}/**/

function prepareAdd(detail) {
      extrainfo.clean(htmlFc)
      customerEmailTracking.clean(htmlFc.fullcontHTML)
      fullcontEntity.prepareAdd(detail, htmlFc)
      handler.hideButtonResetPassword(htmlFc)
}

export function resetFullcont(detail, htmlFc) {
      fullcontEntity.selectOne(detail, htmlFc)
}

async function saveFromDialog(detail, htmlFc) {
      let add = htmlFc.fullcontHTML.classList.contains('mode-add');

      if (add) { //email input
            if (await handler.checkEmailInput(htmlFc, true)) {
                  fullcontEntity.saveFromDialog(detail, htmlFc, processEmail);
            }
      } else {
            if (checkActive(htmlFc) && !await handler.checkEmailInput(htmlFc, true)) {
                  return false;
            }

            const sendWelcomeEmail = shouldSendWelcomeOnUpdate(htmlFc);
            fullcontEntity.saveFromDialog(detail, htmlFc, (data, result) => {
                  processUpdateEmail(data, result, sendWelcomeEmail);
            });
      }
}

//function to send
function editDialog() {
      dialog.start({ act: "show", id: "saveChanges", entity: 'customer' })
}

function deleteDialog(detail) {
      dialog.start({ act: "show", dest: 'customer', id: "deleteElem", entity: 'customer', dbid: detail.dbid })
}

function dtCall(act, result) {
      customerDt.start({ act: act, row: result })
}

function prepareEdit(detail, htmlFc) {

      const div = htmlFc.fullcontHTML.querySelector('#customer_form_email')
      const emailInput = div.querySelector('.elem');
      const estaVacio = emailInput.value !== "";

      div.classList.toggle("disable-mode-edit", estaVacio);

      fullcontHandler.prepareEdit(detail, htmlFc)
}

async function addOne(detail, htmlFc) {
      // Si está activo, validamos el email primero
      if (checkActive(htmlFc)) {
            const isEmailValid = await handler.checkEmailInput(htmlFc, true);

            if (!isEmailValid) {
                  return false;
            }
      }

      fullcontEntity.addOne(detail, htmlFc, processEmail);
      generateImage(detail, htmlFc);

      return true;
}

async function update(detail, htmlFc) {
      if (checkActive(htmlFc)) {
            const isEmailValid = await handler.checkEmailInput(htmlFc, true);

            if (!isEmailValid) {
                  return false;
            }
      }

      const sendWelcomeEmail = shouldSendWelcomeOnUpdate(htmlFc);
      return fullcontEntity.update(detail, htmlFc, (data, result) => {
            processUpdateEmail(data, result, sendWelcomeEmail);
      });
}

function checkActive(htmlFc) {
      const checkbox = htmlFc.fullcontHTML.querySelector('#customer_form_active input[type="checkbox"]');
      return checkbox ? checkbox.checked : false;
}

function shouldSendWelcomeOnUpdate(htmlFc) {
      if (!checkActive(htmlFc)) return false;

      const savedEmail = htmlFc.formCopy.find((field) => field.name === 'email');
      const emailInput = htmlFc.fullcontHTML.querySelector('#customer_form_email input');
      const previousEmail = savedEmail && savedEmail.value != null
            ? `${savedEmail.value}`.trim()
            : '';
      const currentEmail = emailInput ? emailInput.value.trim() : '';

      return previousEmail === '' && currentEmail !== '';
}

function processUpdateEmail(data, result, sendWelcomeEmail) {
      if (sendWelcomeEmail) {
            processEmail(data, result);
            return;
      }

      if (checkActive(htmlFc)) {
            handler.showButtonResetPassword(htmlFc);
      } else {
            handler.hideButtonResetPassword(htmlFc);
      }
}

function processEmail(data, result) {
      if (!checkActive(htmlFc)) {
            handler.hideButtonResetPassword(htmlFc);
            return;
      }

      data.new_user = true;
      handler.sendResetEmail(data, htmlFc);
      handler.showButtonResetPassword(htmlFc);

}

function deleteFromDialog(detail, htmlFc) {

      fullcontEntity.deleteFromDialog(detail, htmlFc)
      setTimeout(() => {
            customerDt.start({ "dest": "customer", "elem": "dt", "act": "select", "entity": "customer" })
      }, 900)

}

function processSelectOne(data, result) {
      const cont = htmlFc.fullcontHTML;
      const id = cont.getAttribute('data-dbid') ?? null;

      setCodeAppBar(data)

      customerEmailTracking.render(result, htmlFc.fullcontHTML)
      extrainfo.fill(result.extrainfo, htmlFc)
      handler.showButtonResetPassword(htmlFc);
      handler.initChatsFc(data.chats)

      navmenu.start({
            act: 'renderNavMenu',
            container: '#customer-navmenu-container',
            items: [
                  {
                        label: 'Send Report',
                        icon: 'send',
                        dest: 'customer',
                        action: 'show',
                        extraData: { entity: 'customer', elem: 'dialog', reportName: 'inventory-item-one', id: 'hellow', dbid: `${id}`, source: 'send', reportType: 'accountReceivable' }
                  },
                  {
                        label: 'Acc. Receivable',
                        icon: 'report_receive',
                        dest: 'customer',
                        action: 'printReport',
                        extraData: { entity: 'customer', elem: 'fullcont', reportName: 'account-receivable-one' }
                  },
                  {
                        label: 'Acc. Receivable Detail',
                        icon: 'detail',
                        dest: 'customer',
                        action: 'printReport',
                        extraData: { entity: 'customer', elem: 'fullcont', reportName: 'account-receivable-detail' }
                  },
                  {
                        label: 'Profit Report',
                        icon: 'profit',
                        dest: 'customer',
                        action: 'printReport',
                        extraData: { entity: 'customer', elem: 'fullcont', reportName: 'customer-profit-one' }
                  }
            ]
      })
}

function setCodeAppBar(data) {
      const cont = htmlFc.fullcontHTML
      const span = cont.querySelectorAll('.customer-code')
      if (!span) return;
      span.forEach(i => {
            i.innerText = `${data.code}`   
      });
}
